<app-selector label="Words Puzzle" [isEmptySelectable]="isEmptySelectable" [data]="wordsPuzzleGameCoreService.wordsPuzzleGameList$| async" displayKey="name"
    [formControl]="ctrl" (refreshEvent)="refresh()" hintStyle="margin-left: -14px; margin-top: -5px" [loading]="wordsPuzzleGameCoreService.loading" [hint]="hint">
</app-selector>
